module.exports = __webpack_public_path__ + "img/m13.1d0fa4cd.png";